import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CancelToken, isCancel } from 'axios';
import Moment from 'moment';

import {
  BOOLEAN,
  CAN_SCAN,
  GAUGE,
  GAUGE_RANGE,
  LOCATION,
  MAP,
  TEXT,
} from '../../Constants/WidgetTypes';
import EventService from '../../Services/EventService';
import { WidthConsumer } from '../../Context/WidthContext';
import ExportSignalCollectionModalDisplay from './ExportSignalCollectionModalDisplay';

export default class ExportSignalCollectionModalContainer extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    widget: PropTypes.object,
    toggleModal: PropTypes.func,
    gatewayID: PropTypes.string,
    orgID: PropTypes.string,
  };

  state = {
    startDate: null,
    endDate: null,
    requestPending: false,
    requestSuccessful: false,
    showTooManyJobsError: false,
    error: '',
  };

  eventService = new EventService();
  source = new CancelToken.source();

  componentWillUnmount() {
    this.source.cancel();
  }

  handleChangeStart = (date) => {
    this.setState({ startDate: date });
  };

  handleChangeEnd = (date) => {
    this.setState({ endDate: date });
  };

  getSignalCollections = () => {
    const { widget: { settings = {}, type = '' } = {} } = this.props;
    const signalCollectionIdSet = new Set();
    switch (true) {
      case type === GAUGE:
      case type === GAUGE_RANGE:
        signalCollectionIdSet.add(settings.datapointID);
        if (settings.secondGauge?.datapointID) {
          signalCollectionIdSet.add(settings.secondGauge.datapointID);
        }
        break;
      case 'lines' in settings:
        settings.lines.forEach(({ datapointID }) => {
          signalCollectionIdSet.add(datapointID);
        });
        break;
      case 'columns' in settings:
        settings.columns.forEach(({ datapointID }) => {
          signalCollectionIdSet.add(datapointID);
        });
        break;
      case TEXT in settings:
        settings.text.forEach(({ datapointID }) => {
          signalCollectionIdSet.add(datapointID);
        });
        break;
      case BOOLEAN in settings:
        settings.boolean.forEach(({ datapointID }) => {
          signalCollectionIdSet.add(datapointID);
        });
        break;
      case CAN_SCAN in settings:
        settings.scan.forEach(({ datapointID }) => {
          signalCollectionIdSet.add(datapointID);
        });
        break;
      case type === LOCATION:
      case type === MAP:
      case 'datapointID' in settings:
        signalCollectionIdSet.add(settings.datapointID);
        break;
    }
    return signalCollectionIdSet;
  };

  handleSave = async () => {
    this.setState({ requestPending: true });
    try {
      const { gatewayID } = this.props;
      const { startDate, endDate } = this.state;
      const datapoints = Array.from(this.getSignalCollections());
      const params = {
        dateStart: Moment(startDate).valueOf(),
        dateStop: Moment(endDate).valueOf(),
      };
      await this.eventService.exportEventsToCSV(
        gatewayID,
        { datapoints },
        params,
        this.source.token
      );
      this.setState({
        requestPending: false,
        requestSuccessful: true,
      });
    } catch (err) {
      if (isCancel(err)) return;
      const error = err.response?.data?.message ?? err.message;
      if (error === 'Too many requests') {
        this.setState({ requestPending: false, showTooManyJobsError: true });
      } else {
        this.setState({ error, requestPending: false });
      }
    }
  };

  render() {
    return (
      <WidthConsumer>
        {(width) => (
          <ExportSignalCollectionModalDisplay
            {...this.props}
            {...this.state}
            handleChangeStart={this.handleChangeStart}
            handleChangeEnd={this.handleChangeEnd}
            handleSave={this.handleSave}
            width={width}
          />
        )}
      </WidthConsumer>
    );
  }
}
